import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/cms/hero/Marco-280.webp")